export default __webpack_public_path__ + "assets/fonts/ddd11dabeca881d49f5966f9a769dc97.woff";